"use client";
import * as React from "react";
import Box from "@mui/material/Box";

interface MainProps {
  children?: React.ReactNode | Array<React.ReactNode>;
}

function Main({ children }: MainProps) {
  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
      {children}
    </Box>
  );
}

export default Main;
